export function getLocalStorageValue<T>(key: string, initialValue: T): T {
  const item = localStorage.getItem(key);
  return item ? JSON.parse(item) : initialValue;
}

export function setLocalStorageValue<T>(key: string, value: T) {
  localStorage.setItem(key, JSON.stringify(value));
}
